import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { posts } from "../blog/posts";
import { Header } from "../components/Header";

const BlogPost: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [content, setContent] = useState<string>("Loading...");

    useEffect(() => {
        if (!slug) return;
        fetch(`/blog/${slug}.md`)
            .then((res) => res.text())
            .then((raw) => {
                // Remove optional YAML front-matter if present so it doesn't render
                const cleaned = raw.replace(/^---[\s\S]*?---\s*/, "");
                setContent(cleaned.trim());
            })
            .catch(() => setContent("Post not found."));
    }, [slug]);

    const meta = posts.find((p) => p.slug === slug);

    return (
        <>
            <Header />
            <div className="min-h-screen px-4 py-24 bg-white">
                <div className="max-w-3xl mx-auto prose prose-pink">
                    <Link to="/blog" className="text-brand-primary hover:underline">
                        ← Back to Blog
                    </Link>
                    {meta && (
                        <>
                            <h1 className="mt-6 text-4xl font-display font-bold">{meta.title}</h1>
                            <p className="text-sm text-gray-500 mb-8">{meta.date}</p>
                        </>
                    )}
                    <ReactMarkdown>{content}</ReactMarkdown>
                </div>
            </div>
        </>
    );
};

export default BlogPost; 